import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OutcomesService, OutcomeSummary } from 'src/app/services/outcomes.service';

@Component({
  selector: 'app-outcomes-table',
  templateUrl: './outcomes-table.component.html',
  styleUrls: ['./outcomes-table.component.scss']
})
export class OutcomesTableComponent implements OnInit, OnDestroy {

  outcomes: OutcomeSummary[];

  unsubscribe: Subject<any> = new Subject;

  constructor(
    private outcomesService: OutcomesService
  ) { }

  ngOnInit() {
    this.outcomesService.getOutcomesSummaries();
    this.outcomesService.outcomesSummaries
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(outcomes => {
        if (outcomes) {
          this.outcomes = outcomes;
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
